import React from 'react';

import {TIconType} from 'components/dynamic-icon/dynamic-icon';
import {SimpleActionButton} from 'components/form/components';
import {EButtonType} from 'entities/metadata';
import {showMessage} from 'shared/utils';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectThunkStatus} from 'store/slices/loading-state-slice';
import {selectRequestData} from 'store/slices/request-slice/request-selectors';
import {updateDocJournalRequest} from 'store/slices/request-slice/request-slice-thunks';

export interface IRequestDocJournalUpdateButtonProps {
    actionTitle?: string;
    actionIcon?: string;
    buttonType?: EButtonType;
}

export const RequestDocJournalUpdateButton = ({
    actionTitle,
    actionIcon,
    buttonType,
}: IRequestDocJournalUpdateButtonProps) => {
    const dispatch = useAppDispatch();
    const requestData: any = useAppSelector(selectRequestData);
    const requestId = requestData?.requests?.id;

    const handleChange = async () => {
        if (requestId) {
            dispatch(updateDocJournalRequest({requestId}))
                .unwrap()
                .then(res => {
                    showMessage({message: res, isError: false});
                })
                .catch(error => {
                    const errorMessage = error?.response?.data;
                    showMessage({
                        message: 'Не удалось обновить реестр документов',
                        description: errorMessage ? `Текст ошибки: «${errorMessage}»` : undefined,
                        isError: true,
                    });
                });
        }
    };

    const {
        isPending: isLoadingUpdateDocJournalRequest,
    } = useAppSelector(s => selectThunkStatus(s, updateDocJournalRequest.typePrefix));

    return (
        <SimpleActionButton
            type={buttonType || 'text'}
            title={actionTitle}
            icon={actionIcon as TIconType}
            onClick={handleChange}
            disabled={isLoadingUpdateDocJournalRequest}
        />
    );
};
